<app-client-info></app-client-info>
<app-case-closed-info></app-case-closed-info>

<app-table [sortOptions]="this.sortOptions" (parentFunc)="table1rowFunc($event)" [sizeOptions]="sizeOptions" [Title]="Title" [Collection]="this.closedCaseCollection" [displayedColumns]="displayedColumns"></app-table>
